var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mb-6 pa-6 pb-4",attrs:{"outlined":""}},[_c('SmsHitoryFilter',{on:{"onFilterChanged":_vm.onFilterChanged}})],1),_c('v-card',{attrs:{"outlined":""}},[_c('SmsHistoryDatatable',{ref:"table"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }